/* eslint no-underscore-dangle: 0 */
import $ from 'jquery';

import GithubIssue from '../schemas/GithubIssueSchema';

const MAX_RESULTS = 10;

const GithubSearch = (token, repositoriesName) => (searchQuery, maxResults = MAX_RESULTS) => new Promise((resolve, reject) => {
    const MEDIA_TYPE = 'application/vnd.github.symmetra-preview+json';
    const GITHUB_SEARCH = 'https://api.github.com/search/issues';
    const beforeSend = (xhr) => {
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.setRequestHeader('Accept', MEDIA_TYPE);
    };
    const type = 'type:issue';
    const repo = repositoriesName.reduce((repoString, repoName) => (`${repoString} repo:${repoName} `), '');
    const encodedQuery = window.encodeURI(`${searchQuery} ${repo} ${type}`);
    const url = `${GITHUB_SEARCH}?q=${encodedQuery}&per_page=${maxResults}`;

    if (searchQuery in window._tettraGithubSearchStore) {
        return resolve(window._tettraGithubSearchStore[searchQuery]);
    }

    return $.ajax({ url, beforeSend })
        .then(({ items }) => {
            const resources = items.map((issue) => (new GithubIssue(issue)));
            window._tettraGithubSearchStore[searchQuery] = resources;
            resolve(resources);
        })
        .catch(reject);
});

const GetGithubIssueData = token => (url) => {
    const beforeSend = (xhr) => {
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    };

    return $.ajax({ url, beforeSend });
};

export { GithubSearch, GetGithubIssueData };
